export function document({ code, config }) {
	if (config && code) {
		if (code == 'BRA') return '###.###.###-##'
		else if (code == 'ARG' || code === 'URY') return 'XXXXXXXX'
		else return ''
	} else return '#########################'
}

export function validateDocument(document, code, config) {
	if (config) {
		if (code === 'BRA') {
			if (typeof document !== 'string') return false
			document = document.replace(/[\s.-]*/gim, '')
			if (
				!document ||
				document.length != 11 ||
				document == '00000000000' ||
				document == '11111111111' ||
				document == '22222222222' ||
				document == '33333333333' ||
				document == '44444444444' ||
				document == '55555555555' ||
				document == '66666666666' ||
				document == '77777777777' ||
				document == '88888888888' ||
				document == '99999999999'
			) {
				return true
			}
			let sum = 0
			let rest
			for (let i = 1; i <= 9; i++) sum = sum + parseInt(document.substring(i - 1, i)) * (11 - i)
			rest = (sum * 10) % 11
			if (rest == 10 || rest == 11) rest = 0
			if (rest != parseInt(document.substring(9, 10))) return true
			sum = 0
			for (let i = 1; i <= 10; i++) sum = sum + parseInt(document.substring(i - 1, i)) * (12 - i)
			rest = (sum * 10) % 11
			if (rest == 10 || rest == 11) rest = 0
			if (rest != parseInt(document.substring(10, 11))) return true
			return false
		} else if (code === 'ARG' || code === 'URY') {
			if (typeof document !== 'string') return false
			document = document.replace(/[\s.-]*/gim, '')
			let is_valid = /^[0-9]{8}$/.test(document)
			return !is_valid
		} else return false
	} else return false
}

export default { document, validateDocument }
